"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Modal = require("./Modal.style");

var _ = require("../");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var CloseIcon = function CloseIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), _react.default.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

CloseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var Modal = function Modal(props) {
  var children = props.children,
      isOpen = props.isOpen,
      showCloseBtn = props.showCloseBtn,
      onToggle = props.onToggle,
      bgColor = props.bgColor,
      id = props.id;
  return _react.default.createElement(_.Portal, null, isOpen && _react.default.createElement(_Modal.StyledModal, _extends({
    id: id,
    bgColor: bgColor
  }, props), showCloseBtn && _react.default.createElement(_Modal.StyledClose, {
    onClick: onToggle
  }, "close", _react.default.createElement(_Modal.StyledIcon, null, _react.default.createElement(CloseIcon, null))), _react.default.createElement(_Modal.StyledModalContainer, null, children)));
};
/**
 * Definition of default values for component props
 */


exports.Modal = Modal;
Modal.defaultProps = {
  children: undefined,
  isOpen: false,
  showCloseBtn: false,
  className: undefined,
  id: 'modal',
  onToggle: undefined,
  bgColor: undefined,
  zIndex: undefined
};
Modal.propTypes = {
  /** Modals content */
  children: _propTypes.default.node,

  /** Should the modal be visible */
  isOpen: _propTypes.default.bool,

  /** Should the close button be visible */
  showCloseBtn: _propTypes.default.bool,

  /** Component className */
  className: _propTypes.default.string,

  /** Component id */
  id: _propTypes.default.string,

  /** onToggle event handler to hide/show Modal programatically */
  onToggle: _propTypes.default.func,

  /** background color for the modal */
  bgColor: _propTypes.default.string,

  /** zIndex for the modal */
  zIndex: _propTypes.default.string
};